import React from 'react';
import { useHistory } from "react-router-dom";
import {Box, Grid} from '@material-ui/core';
import {Tooltip, Link} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import GridViewIcon from '@mui/icons-material/GridView';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import {MetaTags} from 'react-meta-tags';
import DialogTestStart from '../components/DialogTestStart.js';
import DialogTopicTestDetails from '../components/DialogTopicTestDetailsV2.js';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars.js';
import TreeViewComp from '../components/TreeViewComp.js';
import SearchInputA from '../components/SearchInputA.js';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy.js";
import LeftDrawer from "../components/LeftDrawer.js";
import NotificationAlerts from "../components/NotificationAlerts";
import TreeViewCards from '../components/TreeViewCardsV2';
import BreadcrumbsInc from '../components/BreadcrumbsInc';
import BottomDrawerTopicTest from "../components/BottomDrawerTt/BottomDrawerTopicTest.js";
import NewTutorialButton from '../components/StudentTutorial/NewStudentTutorial';
import Cookies from "js-cookie";
import '../styles/bizofficer-a.css';
import { useDispatch, useSelector } from 'react-redux';
///import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';
import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setLearningContents, setTopicTreeTest, setTopicListTest, setMockTest, setContentLimit } from '../store/data.actions';
import { setPopup } from '../store/popup.actions.js';
import StudyMaterialHelpVideoButton from '../components/StudyMaterialHelpVideoButton/StudyMaterialHelpVideoButton.js';


const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  
  export default function Execute() { 
	const dataObj = useSelector(state => state.getData);
	const dispatch = useDispatch();
	const classes = useStyles();
	let history = useHistory();
   const ftue = Cookies.get("ftue");
   const popup1 = useSelector((state => state?.popup1))
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));

	const childRef = React.useRef();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));	
	const childRefStartTest = React.useRef();  
	const [topicTestList, setTopicTestList] = React.useState([]);
	const [testDetail, setTestDetail] = React.useState({});
	const [selectedTopicId, setSelectedTopicId] = React.useState(0);
	const [searchQuery, setSearchQuery] = React.useState(null);
	const [searchFlag, setSearchFlag] = React.useState(null);
	const [showProgress, setShowProgress] = React.useState(false);
	const [showProgressTree, setShowProgressTree] = React.useState(false);
	const [currentRunningTestTitle, setCurrentRunningTestTitle] = React.useState("");
	const [currentRunningTestSession, setCurrentRunningTestSession] = React.useState("");

	// Help Video Icon State
	const [isHelpVideoOpen, setIsHelpVideoOpen] = React.useState(false);

	const [cardsTopicObj, setCardsTopicObj] = React.useState({});
	const [smTab, setSmTab] = React.useState(2);

	const authResult = new URLSearchParams(window.location.search);
	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}

		// check if logged in
		if(localStorage.getItem('etlStudentObj')===null){
			history.push('login');
		}

		


	function showDetails(obj){
		setTestDetail(obj);
		childRef.current.handleClickOpen();		
	}

	const selectTopic = (obj) => {
		setSearchFlag('Topic');
		setSearchQuery(obj.topicName);
		setSelectedTopicId(obj.topicId);
		if(obj.children && obj.children.length && obj.children.length>0){
			setCardsTopicObj(obj);
		}
	}

	const searchBoxQuery = (searchFlag,obj) => {
		setSearchFlag(searchFlag);
		setSearchQuery(obj.title);	
		setSelectedTopicId(obj.id);
	}

	const selectTopicCard = (obj) => {
		if(obj && obj.topicId>0){
			setSearchFlag('Topic');
			setSearchQuery(obj.topicName);
			setSelectedTopicId(obj.topicId);
			if(obj.children && obj.children.length && obj.children.length>0){
				setCardsTopicObj(obj);
			}	
		}else{
			setCardsTopicObj({});
			setTopicTestList([]);
			setSelectedTopicId(0);
			setSearchQuery(null);	
		}
	}

	function startMyTest(){

		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){

			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testcurrentrunning?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					if(response.data.responseTxt=="success"){
						setCurrentRunningTestTitle(response.data.testName);
						setCurrentRunningTestSession(response.data.testSession);
						childRefStartTest.current.handleClickOpen();
					}else if(response && response.data && response.data.responseTxt==="invalidToken"){
						window.localStorage.clear(); 
						history.push('logout');
					}else if(searchQuery){
						window.location.href='testsimulator?testId='+testDetail.mockTestId+'&testType=2';
					}			 				
			}).catch((error) => {
				//console.log("AXIOS ERROR: ", error);
			})	
		}	
	}

	function deleteCurrentStartNew(){		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testrunningdelete?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					///console.log("Just Checking >> "+response.data);
					if(response && response.data && response.data.responseTxt==="invalidToken"){
						window.localStorage.clear(); 
						history.push('logout');
					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})		
			window.location.href='testsimulator?testId='+testDetail.mockTestId+'&testType=2';
		}	
	}	
	function continueCurrentTest(){	
		window.location.href='testsimulator?testSession='+currentRunningTestSession+'&testType=2';
	}

	React.useEffect(() => {
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId!=null && searchQuery!=null && mySelectedCourses[selectedCourse].topicTest==1){
			getApiData(mySelectedCourses[selectedCourse].templateId,searchQuery,selectedTopicId);
		}
	}, [searchQuery, selectedTopicId]); 

	async function getApiData(templateId,topicName,topicId){
		setShowProgress(true);
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/topictestlist/v3?templateId='+templateId+'&topicName='+topicName+'&topicId='+topicId, axiosHeader)
			   .then(response => { 
				setShowProgress(false);
			 	///console.log("Just Checking >> "+response.data);
			   if(response.data && response.data.responseTxt==='success'){
				   setTopicTestList(response.data.obj);	
			   }else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					history.push('logout');
			
			   }				 				
		})
	}

	React.useEffect(() => {		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let diffDays = 0;
			if(localStorage.getItem('cacheDate')){
				let date1 = new Date(localStorage.getItem('cacheDate'));								
				let date2 = new Date();
				let diffTime = date2.getTime() - date1.getTime();
				diffDays = Math.round(diffTime / (1000 * 3600 * 24));
			}
			if(diffDays>0 || localStorage.getItem('templateId')!=mySelectedCourses[selectedCourse].templateId){
				getApiDataCourse(mySelectedCourses[selectedCourse].templateId);
			}
		}
	}, [selectedCourse]);
	
	async function getApiDataCourse(tempId){
		setShowProgressTree(true);
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		///tempId=40;
		axios.get(API_URL+'/templatecache-section?templateId='+tempId+'&section=TopicTest', axiosHeader)
		   .then(response => {
			///document.write(JSON.stringify(response.data));
			if(response.data && response.data.responseTxt==='success'){
				setShowProgressTree(false); 

				localStorage.setItem("templateId", tempId);
				localStorage.setItem("cacheDate", new Date());

					//*********************************
					if(response.data.topicTree && response.data.topicTree.length>10){
						dispatch(setTopicTree(JSON.parse(response.data.topicTree)));
					}else{
						dispatch(setTopicTree([]));
					}
					if(response.data.topicList && response.data.topicList.length>10){
						dispatch(setTopicList(JSON.parse(response.data.topicList)));
					}else{
						dispatch(setTopicList([]));
					}
					if(response.data.keywordList && response.data.keywordList.length>0){
						dispatch(setKeywordList(JSON.parse(response.data.keywordList)));
					}else{
						dispatch(setKeywordList([]));
					}
					if(response.data.smartLearningJson && response.data.smartLearningJson.length>10){
						dispatch(setLearningContents(JSON.parse(response.data.smartLearningJson)));
					}else{
						dispatch(setLearningContents([]));
					}
					if(response.data.topicTreeLearning && response.data.topicTreeLearning.length>10){
						dispatch(setTopicTreeLearning(JSON.parse(response.data.topicTreeLearning)));
					}else{
						dispatch(setTopicTreeLearning([]));
					}
					if(response.data.topicListLearning && response.data.topicListLearning.length>10){
						dispatch(setTopicListLearning(JSON.parse(response.data.topicListLearning)));
					}else{
						dispatch(setTopicListLearning([]));
					}
					if(response.data.keywordListLearning && response.data.keywordListLearning.length>0){
						dispatch(setKeywordListLearning(JSON.parse(response.data.keywordListLearning)));
					}else{
						dispatch(setKeywordListLearning([]));
					}
					if(response.data.topicTreeTest && response.data.topicTreeTest.length>10){
						dispatch(setTopicTreeTest(JSON.parse(response.data.topicTreeTest)));
					}else{
						dispatch(setTopicTreeTest([]));
					}
					if(response.data.topicListTest && response.data.topicListTest.length>10){
						dispatch(setTopicListTest(JSON.parse(response.data.topicListTest)));
					}else{
						dispatch(setTopicListTest([]));
					}
					if(response.data.mockTestJson && response.data.mockTestJson.length>10){
						dispatch(setMockTest(JSON.parse(response.data.mockTestJson)));
					}else{
						dispatch(setMockTest([]));
					}

					if(response.data.contentLimit){
						dispatch(setContentLimit(response.data.contentLimit));
					}else{
						dispatch(setContentLimit({}));
					}

			   }else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					history.push('logout');
			
			   } 
		})
	}

	function selectedTestDetails(obj){
		setTestDetail(obj);
	}

	React.useEffect(() => {
		if(localStorage.getItem('smTab')){
			setSmTab(localStorage.getItem('smTab'));
		}
	}, [localStorage.getItem('smTab')]);

	const handleChangeTabs = (val) => {
		setSmTab(val);
		localStorage.setItem('smTab',val);
	};

		return (
			<div> 
				<MetaTags>
            		<title>Select Topic Test</title>
          		</MetaTags>
				
				<Header />	
	   			<LeftDrawer />

      			<main className={classes.content}>
        		<NotificationAlerts />
				{showProgressTree?<LinearProgress />:null}
				<Box style={{marginLeft:10, marginRight:10}}>
					<Box mt={1}>
						<Grid container spacing={2} >
							<Grid item md={9} xs={12} style={window.screen.width>480?{backgroundColor:'#f5f5fb', minHeight:'85vh', borderRadius:10}:{backgroundColor:'#f5f5fb', minHeight:'120vh', borderRadius:10}} >
								<SearchInputA options={dataObj.topicListTest} label="Search Topic" flag="Topic" toCallParentMethod={searchBoxQuery} />
								<Box mt={1}>
									<Grid container spacing={2}>
										<Grid item md={6} xs={8}>
											<h3 className="heading items_center" ><i className='fa fa-delicious' ></i> Topic Test
											<StudyMaterialHelpVideoButton
											state={isHelpVideoOpen} 
											stateHandler={setIsHelpVideoOpen}
											title={"What is MY Exam Room and how to use it?"}
											link={"https://www.youtube.com/embed/w7M0oCKfUwk?si=LK9DQswWj0DU5oaT"} />
											</h3>
										</Grid>
										<Grid item md={6} xs={4} >
											<div style={{textAlign:'right'}}>
												<Tooltip title="List View" ><GridViewIcon onClick={()=>{handleChangeTabs(1)}} style={smTab==1?{color:'#000000',cursor:'pointer',border:'1px solid #000',marginRight:2,backgroundColor:'#eae8e8'}:{color:'#CCCCCC',cursor:'pointer',border:'1px solid #e0dede',marginRight:2}} /></Tooltip> 
												<Tooltip title="Tree View" ><AccountTreeIcon onClick={()=>{handleChangeTabs(2)}} style={smTab==2?{color:'#000000',cursor:'pointer',border:'1px solid #000',backgroundColor:'#eae8e8'}:{color:'#CCCCCC',cursor:'pointer',border:'1px solid #e0dede'}} /></Tooltip>
											</div>
										</Grid>
									</Grid>
								</Box>	
								<Box mt={1} >
									{smTab==2?<>
										{showProgressTree?<span><CircularProgress size={20} /> Loading...</span>:
										<>
										<p className="headingTwo" style={{marginTop:10}}>Browse Topic & Select</p>
										<TreeViewComp treeViewData={dataObj.topicTreeTest} toCallParentMethod={selectTopic} />
										</>}		
									</>	
									:<>
										{showProgressTree?<span><CircularProgress size={20} /> Loading...</span>:
										<>
										<BreadcrumbsInc topicTree={dataObj.topicTreeTest} topicObj={cardsTopicObj} selectTopic={selectTopicCard} />
										<TreeViewCards topicTree={dataObj.topicTreeTest} topicObj={cardsTopicObj} selectTopic={selectTopicCard} />
										</>}
									</>	
									}
								</Box>

							</Grid>
							{window.screen.width>480?
							<Grid item md={3} xs={12}>
								<Box style={{marginLeft:7}} >
									<Box>
										<Grid container spacing={2} className={searchQuery?"btmbdrgry":null} >
											<Grid item xs={12} >
												<div>{searchQuery?<div><div>Selected Topic:</div><span style={{fontWeight:'bold'}}>{searchQuery}</span></div>:<span style={{color:'red',fontWeight:'bold'}} >Select topic to get topic-test list</span>}</div>
											</Grid>
										</Grid>
									</Box>
									<Box mt={1} className="student_panel_desktop_display" >
										<Box mt={1} className="selfTestForm animate-zoom" >											
											<Box sx={{ width: '100%', bgcolor: 'background.paper' }} >
												
												<div>
													{showProgress?<CircularProgress style={{width:20,height:20}} />:null}
												</div>
												{(topicTestList!=null && topicTestList.length>0)?<>
													<span style={{fontSize:12,color:'#0a2a66',fontWeight:'bold'}}>
														Click below links to start topic test
													</span>								
												<Box component="form" noValidate >
														<ul className='topictestlist'>
															{
																(topicTestList!=null && topicTestList.length>0)?topicTestList.map((myRow,indextt)=>(
																	<li style={{marginLeft:-8}} key={'intt'+indextt}><Link onClick={()=>{showDetails(myRow)}} className='text-line-1' style={{cursor:'pointer', fontWeight:'bold',fontSize:11}} title={myRow.mockTestTitle} >{myRow.mockTestTitle}</Link></li>
																)):null
															}	
														</ul>
												</Box>
												</>
												:searchQuery?<span style={{fontSize:12,color:'#FF0000',fontWeight:'bold'}}>
													No topic test found in {searchQuery}
												</span>
												:null}

											</Box>
											

										</Box>
									</Box>
								</Box>
							</Grid>
							:null}
						</Grid>
					</Box>

				

				</Box>
				</main>
											
				<DialogTopicTestDetails toCallStartTest={startMyTest} testDetail={testDetail} ref={childRef} />
				<DialogTestStart toCallDeleteCurrentStartNew={deleteCurrentStartNew} toCallContinueCurrentTest={continueCurrentTest} currentRunningTestTitle={currentRunningTestTitle} ref={childRefStartTest}  />							 

				<div className="student_panel_mobile_display">
					{(searchQuery && window.screen.width<481)?
						<BottomDrawerTopicTest selectedTestDetails={selectedTestDetails} topicTestList={topicTestList} showProgress={showProgress} searchQuery={searchQuery} searchFlag={searchFlag} startMyTest={startMyTest} deleteCurrentStartNew={deleteCurrentStartNew} continueCurrentTest={continueCurrentTest} currentRunningTestTitle={currentRunningTestTitle} />	
					:null}		
				</div>		

							{ popup1  ? <NewTutorialButton /> : <></>}

			</div>
		);
 
}